import React, { CSSProperties } from 'react'
import Avatar, {
  IProps as IAvatarProps,
  ugcUserLink,
} from 'Components/author/avatar'
import xss from 'xss'
import { emoji } from 'Constants/emoji'
import noopWrapper, { Wrapper } from 'lib/noop-wrapper'
import classNames from 'classnames'
import { size14Class } from 'Components/new/community-card/text'

export interface IProps
  extends Partial<
    Pick<
      IAvatarProps,
      'avatar' | 'userId' | 'userVerified' | 'verifyType' | 'username'
    >
  > {
  labelUrl?: string
  text?: string
  linkWrapper?: Wrapper
  className?: string
  style?: CSSProperties
}

const Answer: React.FC<IProps> = ({
  username,
  avatar,
  userId,
  userVerified,
  verifyType,
  labelUrl,
  text,
  linkWrapper = noopWrapper,
  className = 'tw-bg-common-white',
  style,
}) => {
  return (
    <React.Fragment>
      <div
        className={classNames(
          'wrapper tw-relative tw-mt-16 tw-px-16 tw-pt-16 tw-pb-20',
          className
        )}
        style={style}
      >
        <div className="tw-flex tw-items-center line-1">
          <Avatar
            avatar={avatar}
            userId={userId}
            username={username}
            userVerified={userVerified}
            verifyType={verifyType}
            size={32}
            className="tw-flex-none"
          />
          <p className="tw-ml-12 tw-text-video-shallow-gray line-1">
            {ugcUserLink({ userId })(username)}
          </p>
        </div>
        {linkWrapper(
          <p
            className={classNames(
              'tw-mt-4 tw-ml-44 tw-leading-24 line-2 tw-text-common-black tw-relative tw-z-10 tw-text-justify',
              size14Class
            )}
            dangerouslySetInnerHTML={{
              __html: emoji(xss.filterXSS(text || '')),
            }}
          />
        )}
      </div>
      <style jsx>
        {`
          .wrapper:before {
            content: ${labelUrl ? '""' : 'none'};
            position: absolute;
            right: 0;
            top: 0;
            z-index: 1;
            width: 60px;
            height: 60px;
            background: url(${labelUrl}) center/100% auto no-repeat;
          }
        `}
      </style>
    </React.Fragment>
  )
}

export default Answer
